export default "/images/add-card.png?fc87f12cf78bf744d79e1650ba3ed5c2";